import React from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import styled from 'styled-components';

const StyledFormGroup = styled(Form.Group)`
  margin-bottom: 1.25rem;

  .form-label {
    font-weight: 500;
    color: #495057;
    margin-bottom: 0.5rem;
  }

  .form-control {
    border-radius: 8px;
    padding: 0.5rem 0.75rem;
    border: 1px solid #e0e0e0;
    transition: all 0.3s ease;

    &:focus {
      border-color: #4b6cb7;
      box-shadow: 0 0 0 0.25rem rgba(75, 108, 183, 0.25);
    }

    &.is-invalid {
      border-color: #dc3545;
    }
  }
`;

const AddressInformation = ({ register, errors }) => (
    <>
        <h5 className="section-title">Address details</h5>
        <Row>
            <StyledFormGroup as={Col} md="6">
                <Form.Label>Address<span className="text-danger">*</span></Form.Label>
                <Form.Control
                    type="text"
                    {...register('address')}
                    isInvalid={!!errors.address}
                    placeholder="Enter Address"
                />
                <Form.Control.Feedback type="invalid" className="d-flex align-items-center">
                    <i className="bi bi-exclamation-circle me-2"></i>
                    {errors.address?.message}
                </Form.Control.Feedback>
            </StyledFormGroup>

            <StyledFormGroup as={Col} md="6">
                <Form.Label>City<span className="text-danger">*</span></Form.Label>
                <Form.Control
                    type="text"
                    {...register('city')}
                    isInvalid={!!errors.city}
                    placeholder="Enter City"
                />
                <Form.Control.Feedback type="invalid" className="d-flex align-items-center">
                    <i className="bi bi-exclamation-circle me-2"></i>
                    {errors.city?.message}
                </Form.Control.Feedback>
            </StyledFormGroup>
        </Row>

        <Row>
            <StyledFormGroup as={Col} md="6">
                <Form.Label>District <span className="text-danger">*</span></Form.Label>
                <Form.Control
                    type="text"
                    {...register('district')}
                    isInvalid={!!errors.district}
                    placeholder="Enter district"
                />
                <Form.Control.Feedback type="invalid" className="d-flex align-items-center">
                    <i className="bi bi-exclamation-circle me-2"></i>
                    {errors.district?.message}
                </Form.Control.Feedback>
            </StyledFormGroup>

            <StyledFormGroup as={Col} md="6">
                <Form.Label>Pin code <span className="text-danger">*</span></Form.Label>
                <Form.Control
                    type="text"
                    {...register('pinCode')}
                    isInvalid={!!errors.pinCode}
                    placeholder="Enter Pin code"
                />
                <Form.Control.Feedback type="invalid" className="d-flex align-items-center">
                    <i className="bi bi-exclamation-circle me-2"></i>
                    {errors.pinCode?.message}
                </Form.Control.Feedback>
            </StyledFormGroup>
        </Row>
    </>
);

export default AddressInformation;